import { useSelector } from "react-redux";
import { useProjectContext } from "~/areas/projects/context";
import { ProcessType } from "~/client/resources";
import type { NameOrIdKey } from "~/components/KeyAccessProvider/types";
import { useOptionalRunbookContext } from "../../Runbooks/RunbookContext";
import { isVersionControlledProcess } from "../Common/CommonProcessHelpers";

const isConfigurationAsCodeForRunbooksEnabledSelector = (state: GlobalState) => state.configurationArea.features.isConfigurationAsCodeForRunbooksEnabled;

export const useKeyedItemAccessForConfigurationAsCode = (): NameOrIdKey => {
    const projectContext = useProjectContext();
    const runbookContext = useOptionalRunbookContext();
    const isConfigurationAsCodeForRunbooksEnabled = useSelector(isConfigurationAsCodeForRunbooksEnabledSelector);
    const isVersionControlled = isVersionControlledProcess(projectContext.state.model.IsVersionControlled, runbookContext ? ProcessType.Runbook : ProcessType.Deployment, !!isConfigurationAsCodeForRunbooksEnabled);

    return isVersionControlled ? "Name" : "Id";
};

export default useKeyedItemAccessForConfigurationAsCode;
